/**
 * tools (API)
 *  tools関連のAPI
 */
import session from './session'
//import file from './file'


var uri = process.env.API_ENDPOINT

export default {
    postText (data) {
      return session.post(uri + '/api/tl/post_text/',data)
    },
    getText (state) {
      return session.get(uri + '/api/tl/get_text/',state)
    },
    updateText (data) {
      return session.post(uri + '/api/tl/update_text/', data)
    },
    deleteText (contentsid) {
      return session.delete(uri + '/api/tl/delete_text/' + contentsid + '/')
    },
    changeText (data){
      return session.post(uri + '/api/tl/change_text/', data)
    },
    readNotification (data) {
      return session.patch(uri + '/api/tl/read_notification/', data)
    },
    async fullSearch (data) {
      return await session.post(uri + '/api/tl/full_search/', data)
    }
}







// WEBPACK FOOTER //
// ./src/api/tools.js